import { useState } from "react";
import { Form, Input, Button, Checkbox, message } from "antd";
import { Redirect } from "react-router-dom";
import { getAccessTokenApi } from "../../api/auth";
import { CONST_ACCESS_TOKEN } from "../../utils/constants";
import { login } from "../../api/sistema";

function Login() {
  const [passwordType, setPasswordType] = useState("password");
  const [isLogging, setIsLogging] = useState(false);

  if (getAccessTokenApi()) {
    return <Redirect to="/app" />;
  }

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  // ------ Conecta con endpoint ------
  const sendDataToServer = async (data) => {
    try {
      setIsLogging(true);
      const response = await login(data);
      setIsLogging(false);
      setTokensToLocalStorage(response);
      message.success("¡Bienvenido!");
      console.log(response);
      window.location.href = "/sistema";
    } catch (err) {
      setIsLogging(false);
      message.error(err.message);
    }
  };

  /**
   * setTokensToLocalStorage
   * @param {String} data
   */
  const setTokensToLocalStorage = ({ payload }) => {
    localStorage.setItem(CONST_ACCESS_TOKEN, payload.token);
  };

  /**
   * showPassword
   * @param {Boolean} isChecked
   */
  const showPassword = (isChecked) => {
    if (isChecked) {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <div className="w-64 mx-auto">
      <h1 className="text-2xl font-bold my-8 text-center">
        Inicia sesión como <br />
        <span className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-700">
          REGISTRADOR
        </span>
      </h1>

      <Form initialValues={{ remember: true }} onFinish={onFinish} layout="vertical">
        <Form.Item
          name="nrodocumento"
          rules={[
            {
              required: true,
              message: "El usuario necesario"
            }
          ]}
        >
          <Input placeholder="Usuario" />
        </Form.Item>

        <Form.Item
          name="claveSistema"
          rules={[{ required: true, message: "La contraseña es necesaria" }]}
        >
          <Input type={passwordType} placeholder="Clave de sistema" />
        </Form.Item>

        <Checkbox onClick={(e) => showPassword(e.target.checked)}>Mostrar contraseña</Checkbox>

        <Form.Item>
          <Button type="primary" block className="mt-8" loading={isLogging} htmlType="submit">
            Iniciar sesión
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default Login;
